<template>
  <div>
    <ZLoader v-if="isLoading" />
    <div
      v-else
      class="w-full h-auto bg-white rounded-bl-[20px] rounded-br-[20px] justify-around items-start flex"
    >
      <!-- Headers -->
      <div class="w-[4%] flex-col justify-start items-start inline-flex">
        <!-- ticket_number Header -->
        <div
          @click="sortTable('ticket_number')"
          class="self-stretch h-12 px-4 py-3 bg-slate-50 border-b border-slate-200 justify-between items-center cursor-pointer bg-gray-300"
        >
          <div class="justify-start items-center gap-1 flex">
            <div
              class="text-neutral-900 text-sm font-medium font-['Public Sans'] leading-snug"
            >
              Ticket #
            </div>
            <span v-if="sortKey === 'ticket_number'">
              {{ sortDirection === "asc" ? "↑" : "↓" }}
            </span>
          </div>
        </div>
        <!-- ticket_number Data -->
        <div
          v-for="(item, index) in sortedTable"
          :key="index"
          :class="[
            'self-stretch h-[72px] p-4 border-b border-slate-200 justify-start items-center gap-3 flex',
            index % 2 === 0 ? 'bg-white' : 'bg-gray-300',
          ]"
        >
          <div
            class="grow shrink basis-0 text-slate-600 text-sm font-normal font-['Public Sans'] leading-snug"
          >
            {{ item.ticket_number }}
          </div>
        </div>
      </div>

      <div class="w-[9%] flex-col justify-start items-start inline-flex">
        <!-- submission_date Header -->
        <div
          @click="sortTable('submission_date')"
          class="self-stretch h-12 px-4 py-3 bg-slate-50 border-b border-slate-200 justify-between items-center cursor-pointer bg-gray-300"
        >
          <div class="justify-start items-center gap-1 flex">
            <div
              class="text-neutral-900 text-sm font-medium font-['Public Sans'] leading-snug"
            >
              Submission Date
            </div>
            <span v-if="sortKey === 'submission_date'">
              {{ sortDirection === "asc" ? "↑" : "↓" }}
            </span>
          </div>
        </div>
        <!-- submission_date Data -->
        <div
          v-for="(item, index) in sortedTable"
          :key="'submission_date-' + index"
          :class="[
            'self-stretch h-[72px] p-4 border-b border-slate-200 justify-start items-center gap-3 flex',
            index % 2 === 0 ? 'bg-white' : 'bg-gray-300',
          ]"
        >
          <div
            class="grow shrink basis-0 text-slate-600 text-left text-sm font-normal font-['Public Sans'] leading-snug"
          >
            {{ formatDate(item.submission_date) }}
          </div>
        </div>
      </div>

      <div
        v-if="selectedType == 'commercial'"
        class="w-[9%] flex-col justify-start items-start inline-flex"
      >
        <!-- business_name Header -->
        <div
          @click="sortTable('business_name')"
          class="self-stretch h-12 px-4 py-3 bg-slate-50 border-b border-slate-200 justify-between items-center cursor-pointer bg-gray-300"
        >
          <div class="justify-start items-center gap-1 flex">
            <div
              class="text-neutral-900 text-sm font-medium font-['Public Sans'] leading-snug"
            >
              Business Name
            </div>
            <span v-if="sortKey === 'business_name'">
              {{ sortDirection === "asc" ? "↑" : "↓" }}
            </span>
          </div>
        </div>
        <!-- business_name Data -->
        <div
          v-for="(item, index) in sortedTable"
          :key="'business_name-' + index"
          :class="[
            'self-stretch h-[72px] p-4 border-b border-slate-200 justify-start items-center gap-3 flex',
            index % 2 === 0 ? 'bg-white' : 'bg-gray-300',
          ]"
        >
          <div
            class="grow shrink basis-0 text-slate-600 text-left text-sm font-normal font-['Public Sans'] leading-snug"
          >
            {{ item.business_name }}
          </div>
        </div>
      </div>

      <div class="w-[9%] flex-col justify-start items-start inline-flex">
        <!-- customer_name Header -->
        <div
          @click="sortTable('customer_name')"
          class="self-stretch h-12 px-4 py-3 bg-slate-50 border-b border-slate-200 justify-between items-center cursor-pointer bg-gray-300"
        >
          <div class="justify-start items-center gap-1 flex">
            <div
              class="text-neutral-900 text-sm font-medium font-['Public Sans'] leading-snug"
            >
              Customer Name
            </div>
            <span v-if="sortKey === 'customer_name'">
              {{ sortDirection === "asc" ? "↑" : "↓" }}
            </span>
          </div>
        </div>
        <!-- customer_name Data -->
        <div
          v-for="(item, index) in sortedTable"
          :key="'customer_name-' + index"
          :class="[
            'self-stretch h-[72px] p-4 border-b border-slate-200 justify-start items-center gap-3 flex',
            index % 2 === 0 ? 'bg-white' : 'bg-gray-300',
          ]"
        >
          <div
            class="grow shrink basis-0 text-slate-600 text-left text-sm font-normal font-['Public Sans'] leading-snug"
          >
            {{ item.customer_name }}
          </div>
        </div>
      </div>

      <div
        v-if="selectedType == 'commercial'"
        class="w-[9%] flex-col justify-start items-start inline-flex"
      >
        <!-- commercial_first_name Header -->
        <div
          @click="sortTable('commercial_first_name')"
          class="self-stretch h-12 px-4 py-3 bg-slate-50 border-b border-slate-200 justify-between items-center cursor-pointer bg-gray-300"
        >
          <div class="justify-start items-center gap-1 flex">
            <div
              class="text-neutral-900 text-sm font-medium font-['Public Sans'] leading-snug"
            >
              Commercial First Name
            </div>
            <span v-if="sortKey === 'commercial_first_name'">
              {{ sortDirection === "asc" ? "↑" : "↓" }}
            </span>
          </div>
        </div>
        <!-- commercial_first_name Data -->
        <div
          v-for="(item, index) in sortedTable"
          :key="'commercial_first_name-' + index"
          :class="[
            'self-stretch h-[72px] p-4 border-b border-slate-200 justify-start items-center gap-3 flex',
            index % 2 === 0 ? 'bg-white' : 'bg-gray-300',
          ]"
        >
          <div
            class="grow shrink basis-0 text-slate-600 text-left text-sm font-normal font-['Public Sans'] leading-snug"
          >
            {{ item.commercial_first_name }}
          </div>
        </div>
      </div>

      <div
        v-if="selectedType == 'commercial'"
        class="w-[9%] flex-col justify-start items-start inline-flex"
      >
        <!-- commercial_last_name Header -->
        <div
          @click="sortTable('commercial_last_name')"
          class="self-stretch h-12 px-4 py-3 bg-slate-50 border-b border-slate-200 justify-between items-center cursor-pointer bg-gray-300"
        >
          <div class="justify-start items-center gap-1 flex">
            <div
              class="text-neutral-900 text-sm font-medium font-['Public Sans'] leading-snug"
            >
              Commercial Last Name
            </div>
            <span v-if="sortKey === 'commercial_last_name'">
              {{ sortDirection === "asc" ? "↑" : "↓" }}
            </span>
          </div>
        </div>
        <!-- commercial_last_name Data -->
        <div
          v-for="(item, index) in sortedTable"
          :key="'commercial_last_name-' + index"
          :class="[
            'self-stretch h-[72px] p-4 border-b border-slate-200 justify-start items-center gap-3 flex',
            index % 2 === 0 ? 'bg-white' : 'bg-gray-300',
          ]"
        >
          <div
            class="grow shrink basis-0 text-slate-600 text-left text-sm font-normal font-['Public Sans'] leading-snug"
          >
            {{ item.commercial_last_name }}
          </div>
        </div>
      </div>

      <div class="w-[14%] flex-col justify-start items-start inline-flex">
        <!-- customer_email Header -->
        <div
          class="self-stretch h-12 px-4 py-3 bg-slate-50 border-b border-slate-200 justify-start items-center gap-3 inline-flex bg-gray-300"
        >
          <div class="justify-start items-center gap-1 flex">
            <div
              class="text-neutral-900 text-sm font-medium font-['Public Sans'] leading-snug"
            >
              Customer Email
            </div>
          </div>
        </div>
        <!-- customer_email Data -->
        <div
          v-for="(item, index) in sortedTable"
          :key="'customer_email-' + index"
          :class="[
            'self-stretch h-[72px] p-4 border-b border-slate-200 justify-start items-center gap-3 flex',
            index % 2 === 0 ? 'bg-white' : 'bg-gray-300',
          ]"
        >
          <div
            class="grow shrink basis-0 text-slate-600 text-left text-sm font-normal font-['Public Sans'] leading-snug"
          >
            {{ item.customer_email }}
          </div>
        </div>
      </div>

      <div class="w-[9%] flex-col justify-start items-start inline-flex">
        <!-- contact_phone Header -->
        <div
          class="self-stretch h-12 px-4 py-3 bg-slate-50 border-b border-slate-200 justify-start items-center gap-3 inline-flex bg-gray-300"
        >
          <div class="justify-start items-center gap-1 flex">
            <div
              class="text-neutral-900 text-sm font-medium font-['Public Sans'] leading-snug"
            >
              Contact Phone
            </div>
          </div>
        </div>
        <!-- contact_phone Data -->
        <div
          v-for="(item, index) in sortedTable"
          :key="'contact_phone-' + index"
          :class="[
            'self-stretch h-[72px] p-4 border-b border-slate-200 justify-start items-center gap-3 flex',
            index % 2 === 0 ? 'bg-white' : 'bg-gray-300',
          ]"
        >
          <div
            class="grow shrink basis-0 text-slate-600 text-left text-sm font-normal font-['Public Sans'] leading-snug"
          >
            {{ item.contact_phone }}
          </div>
        </div>
      </div>

      <div class="w-[9%] flex-col justify-start items-start inline-flex">
        <!-- submission_date Header -->
        <div
          class="self-stretch h-12 px-4 py-3 bg-slate-50 border-b border-slate-200 justify-start items-center gap-3 inline-flex bg-gray-300"
        >
          <div class="justify-start items-center gap-1 flex">
            <div
              class="text-neutral-900 text-sm font-medium font-['Public Sans'] leading-snug"
            >
              Address
            </div>
          </div>
        </div>
        <!-- address Data -->
        <div
          v-for="(item, index) in sortedTable"
          :key="'address-' + index"
          :class="[
            'self-stretch h-[72px] p-4 border-b border-slate-200 justify-start items-center gap-3 flex',
            index % 2 === 0 ? 'bg-white' : 'bg-gray-300',
          ]"
        >
          <div
            class="grow shrink basis-0 text-slate-600 text-left text-sm font-normal font-['Public Sans'] leading-snug"
          >
            {{ item.address }}
          </div>
        </div>
      </div>

      <div class="w-[4%] flex-col justify-start items-start inline-flex">
        <!-- current_customer Header -->
        <div
          class="self-stretch h-12 px-4 py-3 bg-slate-50 border-b border-slate-200 justify-start items-center gap-3 inline-flex bg-gray-300"
        >
          <div class="justify-start items-center gap-1 flex">
            <div
              class="text-neutral-900 text-sm font-medium font-['Public Sans'] leading-snug"
            >
              Current Customer
            </div>
          </div>
        </div>
        <!-- current_customer Data -->
        <div
          v-for="(item, index) in sortedTable"
          :key="'current_customer-' + index"
          :class="[
            'self-stretch h-[72px] p-4 border-b border-slate-200 justify-start items-center gap-3 flex',
            index % 2 === 0 ? 'bg-white' : 'bg-gray-300',
          ]"
        >
          <div
            class="grow shrink basis-0 text-slate-600 text-left text-sm font-normal font-['Public Sans'] leading-snug"
          >
            {{ item.current_customer }}
          </div>
        </div>
      </div>

      <div class="w-[7%] flex-col justify-start items-start inline-flex">
        <!-- status Header -->
        <div
          class="self-stretch h-12 px-4 py-3 bg-slate-50 border-b border-slate-200 justify-start items-center gap-3 inline-flex bg-gray-300"
        >
          <div class="justify-start items-center gap-1 flex">
            <div
              class="text-neutral-900 text-sm font-medium font-['Public Sans'] leading-snug"
            >
              Status
            </div>
          </div>
        </div>
        <!-- status Data -->
        <div
          v-for="(item, index) in sortedTable"
          :key="'status-' + index"
          :class="[
            'self-stretch h-[72px] p-4 border-b border-slate-200 justify-start items-center gap-3 flex',
            index % 2 === 0 ? 'bg-white' : 'bg-gray-300',
          ]"
        >
          <div
            class="grow shrink basis-0 text-slate-600 text-left text-sm font-normal font-['Public Sans'] leading-snug"
          >
            {{ item.status }}
          </div>
        </div>
      </div>

      <div class="w-[6%] flex-col justify-start items-start inline-flex">
        <!-- customer_type Header -->
        <div
          class="self-stretch h-12 px-4 py-3 bg-slate-50 border-b border-slate-200 justify-start items-center gap-3 inline-flex bg-gray-300"
        >
          <div class="justify-start items-center gap-1 flex">
            <div
              class="text-neutral-900 text-sm font-medium font-['Public Sans'] leading-snug"
            >
              Customer Type
            </div>
          </div>
        </div>
        <!-- customer_type Data -->
        <div
          v-for="(item, index) in sortedTable"
          :key="'customer_type-' + index"
          :class="[
            'self-stretch h-[72px] p-4 border-b border-slate-200 justify-start items-center gap-3 flex',
            index % 2 === 0 ? 'bg-white' : 'bg-gray-300',
          ]"
        >
          <div
            class="grow shrink basis-0 text-slate-600 text-left text-sm font-normal font-['Public Sans'] leading-snug"
          >
            {{ item.customer_type }}
          </div>
        </div>
      </div>

      <div class="w-[15%] flex-col justify-start items-start inline-flex">
        <!-- residential_products_selected Header -->
        <div
          class="self-stretch h-12 px-4 py-3 bg-slate-50 border-b border-slate-200 justify-start items-center gap-3 inline-flex bg-gray-300"
        >
          <div class="justify-start items-center gap-1 flex">
            <div
              class="text-neutral-900 text-sm font-medium font-['Public Sans'] leading-snug"
            >
              {{
                selectedType == "residential"
                  ? "Residential Products Selected"
                  : "Commercial Products Selected"
              }}
            </div>
          </div>
        </div>
        <!-- residential_products_selected Data -->

        <div
          v-for="(item, index) in sortedTable"
          :key="'residential_products_selected-' + index"
          :class="[
            'self-stretch h-[72px] p-4 border-b border-slate-200 justify-start items-center gap-3 flex',
            index % 2 === 0 ? 'bg-white' : 'bg-gray-300',
          ]"
        >
          <div
            class="grow shrink basis-0 text-slate-600 text-left text-sm font-normal font-['Public Sans'] leading-snug"
          >
            {{
              selectedType === "residential"
                ? item.residential_products_selected &&
                  item.residential_products_selected.match(/,|\n|(?<=\$\d+)n/)
                  ? item.residential_products_selected.split(
                      /,|\n|(?<=\$\d+)n/
                    )[0] + "..."
                  : item.residential_products_selected ||
                    "No products available"
                : item.commercial_products_selected &&
                  item.commercial_products_selected.match(/,|\n|(?<=\$\d+)n/)
                ? item.commercial_products_selected.split(
                    /,|\n|(?<=\$\d+)n/
                  )[0] + "..."
                : item.commercial_products_selected || "No products available"
            }}
            <button
              @click="
                showModalFunction(
                  selectedType === 'residential'
                    ? item.residential_products_selected
                    : item.commercial_products_selected.replace(
                        /(?<=\$\d+)n/g,
                        ', '
                      ),
                  'products'
                )
              "
              class="px-1.5 py-[2px] bg-blue_primary rounded-lg shadow justify-center items-center gap-2 flex"
            >
              <div class="text-white text-base font-semibold leading-normal">
                See All
              </div>
            </button>
          </div>
        </div>
      </div>

      <div class="w-[4%] flex-col justify-start items-start inline-flex">
        <!-- residential_reward_points Header -->
        <div
          class="self-stretch h-12 px-4 py-3 bg-slate-50 border-b border-slate-200 justify-start items-center gap-3 inline-flex bg-gray-300"
        >
          <div class="justify-start items-center gap-1 flex">
            <div
              class="text-neutral-900 text-sm font-medium font-['Public Sans'] leading-snug"
            >
              {{
                selectedType == "residential"
                  ? "Residential Reward Points"
                  : "Commercial Reward Points"
              }}
            </div>
          </div>
        </div>
        <!-- residential_reward_points Data -->
        <div
          v-for="(item, index) in sortedTable"
          :key="'residential_reward_points-' + index"
          :class="[
            'self-stretch h-[72px] p-4 border-b border-slate-200 justify-start items-center gap-3 flex',
            index % 2 === 0 ? 'bg-white' : 'bg-gray-300',
          ]"
        >
          <div
            class="grow shrink basis-0 text-slate-600 text-left text-sm font-normal font-['Public Sans'] leading-snug"
          >
            {{
              selectedType == "residential"
                ? item.residential_reward_points
                : item.commercial_reward_points
            }}
          </div>
        </div>
      </div>

      <div class="w-[22%] flex-col justify-start items-start inline-flex">
        <!-- submitter_notes_comments Header -->
        <div
          class="self-stretch h-12 px-4 py-3 bg-slate-50 border-b border-slate-200 justify-start items-center gap-3 inline-flex bg-gray-300"
        >
          <div class="justify-start items-center gap-1 flex">
            <div
              class="text-neutral-900 text-sm font-medium font-['Public Sans'] leading-snug"
            >
              Submitter Notes
            </div>
          </div>
        </div>
        <!-- submitter_notes_comments Data -->
        <div
          v-for="(item, index) in sortedTable"
          :key="'submitter_notes_comments-' + index"
          :class="[
            'self-stretch h-[72px] p-4 border-b border-slate-200 justify-start items-center gap-3 flex',
            index % 2 === 0 ? 'bg-white' : 'bg-gray-300',
          ]"
        >
          <div
            class="grow shrink basis-0 text-slate-600 text-left text-sm font-normal font-['Public Sans'] leading-snug"
          >
            {{ truncateText(item.submitter_notes_comments, 100) }}
            <button
              @click="showModalFunction(item.submitter_notes_comments, 'notes')"
              class="px-1.5 py-[2px] bg-blue_primary rounded-lg shadow justify-center items-center gap-2 flex"
            >
              <div class="text-white text-base font-semibold leading-normal">
                See All
              </div>
            </button>
          </div>
        </div>
      </div>
      <div class="fixed bottom-4 right-4 flex flex-col space-y-4 z-50">
        <button
          @click="exportCSV"
          @mouseenter="showTooltip('Download CSV of current page')"
          @mouseleave="hideTooltip"
          class="px-4 py-3 bg-green-500 text-white font-semibold rounded-full shadow-lg hover:bg-green-600 transition"
        >
          Export to CSV
        </button>
        <button
          @click="exportFullCSV"
          @mouseenter="showTooltip('Download full CSV of all pages')"
          @mouseleave="hideTooltip"
          class="px-4 py-3 bg-blue_primary text-white font-semibold rounded-full shadow-lg hover:bg-blue-600 transition"
        >
          Export all data
        </button>

        <div
          v-if="tooltipVisible"
          class="absolute bg-gray-700 text-white text-s rounded px-2 py-1 tooltip-left"
        >
          {{ tooltipMessage }}
        </div>
      </div>
    </div>
    <NotesModal
      v-if="showModal"
      :visible="showModal"
      @close="showModal = false"
      :text="textModal"
      :type="typeModal"
    >
    </NotesModal>
    <Pagination />
  </div>
</template>
  

<script>
import { computed, onMounted, ref, watchEffect } from "vue";
import { useStore } from "vuex";
import Pagination from "./TablePagination.vue";
import ZLoader from "./ZLoader.vue";
import NotesModal from "./NotesModal.vue";

export default {
  components: { Pagination, ZLoader, NotesModal },

  setup() {
    const store = useStore();
    const table = computed(() => store.getters.pagination.data);
    const userData = JSON.parse(sessionStorage.getItem("userData"));
    const isLoading = computed(() => store.getters.loading);
    const showModal = ref(false);
    const textModal = ref("");
    const typeModal = ref("");
    const sortKey = ref("");
    const sortDirection = ref("asc");
    const selectedType = ref(
      sessionStorage.getItem("selectedButton") || "residential"
    );
    const tooltipVisible = ref(false);
    const tooltipMessage = ref("");

    window.addEventListener("storage", () => {
      selectedType.value =
        sessionStorage.getItem("selectedButton") || "residential";
    });
    watchEffect(() => {
      const storedType = sessionStorage.getItem("selectedButton");
      if (storedType) {
        selectedType.value = storedType;
      }
    });

    function showModalFunction(text, type) {
      (typeModal.value = type), (textModal.value = text);
      showModal.value = true;
    }

    const sortTable = (key) => {
      if (sortKey.value === key) {
        sortDirection.value = sortDirection.value === "asc" ? "desc" : "asc";
      } else {
        sortKey.value = key;
        sortDirection.value = "asc";
      }
    };

    const sortedTable = computed(() => {
      if (table.value) {
        if (!sortKey.value) return table.value;
        return [...table.value].sort((a, b) => {
          let result = 0;
          if (a[sortKey.value] < b[sortKey.value]) result = -1;
          if (a[sortKey.value] > b[sortKey.value]) result = 1;
          return sortDirection.value === "asc" ? result : -result;
        });
      }
      return undefined;
    });

    function formatDate(dateString) {
      let date = new Date(dateString);

      let month = (date.getMonth() + 1).toString().padStart(2, "0");
      let day = date.getDate().toString().padStart(2, "0");
      let year = date.getFullYear();

      return `${month}/${day}/${year}`;
    }

    async function exportCSV() {
      isLoading.value = true;
      await store.dispatch("downloadCSV");
      isLoading.value = false;
    }

    async function exportFullCSV() {
      isLoading.value = true;
      await store.dispatch("downloadFullCSV");
      isLoading.value = false;
    }
    function showTooltip(message) {
      this.tooltipMessage = message;
      this.tooltipVisible = true;
    }
    function hideTooltip() {
      this.tooltipVisible = false;
    }

    onMounted(async () => {
      await store.commit("setLoading", true);
      await store.dispatch("fetchData", {
        submitter_email_contact: userData.email,
        page: 1,
        limit: 15,
      });
      await store.commit("setLoading", false);
    });

    function truncateText(text, maxLength) {
      if (text && text.length > maxLength) {
        return text.substring(0, maxLength) + "...";
      }
      return text;
    }

    return {
      table,
      sortedTable,
      sortKey,
      sortDirection,
      sortTable,
      truncateText,
      selectedType,
      isLoading,
      showModal,
      showModalFunction,
      textModal,
      typeModal,
      formatDate,
      exportCSV,
      exportFullCSV,
      tooltipVisible,
      tooltipMessage,
      showTooltip,
      hideTooltip,
    };
  },
};
</script>
<style scoped>
.tooltip-left {
  top: 50%;
  right: 100%;
  transform: translateY(-50%);
  margin-right: 10px;
  width: 150px;
}
</style>
